var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v(_vm._s(_vm.$t('sidebar.hestaprereport')))])]),(_vm.reportDetails.workspaceId)?_c('div',{staticClass:"col-12"},[_c('PowerBiCard',{attrs:{"powerbireport":_vm.reportDetails}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }